(() => {
  function initialize(root = document) {
    root.querySelectorAll('[data-cx-library]').forEach(library => {
      if (library.dataset.initialized) return;
      library.dataset.initialized = 'true';
      const items = [...library.querySelectorAll('[data-cx-guide]')];
      const buttons = [...library.querySelectorAll('[data-cx-category]')];
      const input = library.querySelector('[data-cx-search]');
      let category = 'all';
      function filter() {
        const query = (input?.value || '').trim().toLowerCase();
        let shown = 0;
        items.forEach(item => {
          const match = (category === 'all' || item.dataset.category === category) && item.textContent.toLowerCase().includes(query);
          item.hidden = !match;
          if (match) shown++;
        });
        buttons.forEach(b => b.setAttribute('aria-pressed', String(b.dataset.cxCategory === category)));
        const empty = library.querySelector('[data-cx-empty]');
        if (empty) empty.hidden = shown > 0;
        const status = library.querySelector('[data-cx-status]');
        if (status) status.textContent = `${shown} starter guides`;
      }
      buttons.forEach(button => button.addEventListener('click', () => { category = button.dataset.cxCategory; filter(); }));
      input?.addEventListener('input', filter);
      library.cxReset = () => { category = 'all'; if(input) input.value = ''; filter(); };
    });
  }
  function revealHash() {
    let id;
    try { id = decodeURIComponent(window.location.hash.slice(1)); } catch { return; }
    const target = document.getElementById(id);
    if (target?.matches('[data-cx-guide]')) {
      target.closest('[data-cx-library]')?.cxReset?.();
      target.hidden = false;
      target.open = true;
      target.scrollIntoView({ block: 'start' });
    }
  }
  initialize();
  revealHash();
  window.addEventListener('hashchange', revealHash);
  document.addEventListener('shopify:section:load', e => { initialize(e.target); revealHash(); });
  document.addEventListener('click', e => {
    const link = e.target.closest('a[href*="#guide-"]');
    if (link && new URL(link.href).pathname === location.pathname) setTimeout(revealHash, 0);
  });
})();
